import { useEffect, useState } from 'react';
import { createClient } from '@wix/sdk';
import { element } from '@wix/editor';
import { GlobalDesignStyleGroup } from '../../types';
import { GroupStyleType, GroupValue } from './types';

export const useGroupComponentProps = <T, Type extends GroupStyleType>(
  group: GlobalDesignStyleGroup,
  // NOTE: cssProperties & cssCustomProperties already prefilled with default value, probably we don't need defaultValue here
  defaultValue: T,
  reducer: (acc: Record<keyof T, any>, styleValues: GroupValue<Type>) => any,
) => {
  const [groupComponentProps, setGroupComponentProps] = useState<T>(
    JSON.parse(JSON.stringify(defaultValue)),
  );

  const getComponentProps = async () => {
    const client = createClient({
      host: group.host,
      modules: { element },
    });
    // TODO: support both cssProperties + cssCustomProperties
    const cssProperties = (await client.element.getStyles())
      .cssProperties as unknown as Record<string, GroupValue<Type>>;

    const styleValues = Object.values(cssProperties);

    const componentProps = styleValues.reduce(
      reducer,
      JSON.parse(JSON.stringify(defaultValue)),
    );

    setGroupComponentProps(componentProps);
  };

  useEffect(() => {
    getComponentProps();
  }, []);

  return groupComponentProps;
};
